// Ügyfél-státusz badge — a jel a KÖZÖS badge-katalógus `lifecycle` fogalmából (`domain-badge.tsx`): az
// `active`/`pending`/`inactive` hármas ugyanazt jelenti az ügyfélnél, a fióknál és a szolgáltatás-
// hozzárendelésnél is, ezért EGY térkép írja le (korábban ez a map bájtra duplikálva élt a client- és az
// account-badge-ben, a service-badge pedig eltért).
import { DomainBadge } from '@/components/shared/domain-badge';

export interface ClientStatusBadgeProps {
  /** A nyers státusz-string (szín + ikon forrása). */
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('clients.statusLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function ClientStatusBadge({
  status,
  label,
  className,
}: ClientStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="lifecycle" value={status} label={label} className={className} />;
}
